module.exports = __webpack_public_path__ + "img/programs-black-icon.23f362dd.png";